// API Endpoints Configuration
const isProd = process.env.NODE_ENV === 'production';

// Local development endpoints
const devApiUrl = 'http://localhost:8787'; // Local wrangler dev server
const devSocketUrl = 'http://localhost:8788'; // Local socket service

// Production endpoints with your Cloudflare domain
const prodApiUrl = 'https://api.slotchess.com'; // Replace with your API Worker URL
const prodSocketUrl = 'wss://socket.slotchess.com'; // Replace with your Socket Worker URL

// Export the configuration
export const API_URL = isProd ? prodApiUrl : devApiUrl;
export const SOCKET_URL = isProd ? prodSocketUrl : devSocketUrl;

// Helper to construct full API URLs
export const endpoint = (path) => `${API_URL}${path}`;